/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable react/sort-comp */
/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { Box, Chip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import infoIcon from 'assets/img/infoIcon.svg';
import greenTick from 'assets/img/greenCheck.svg';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import purple from '@material-ui/core/colors/purple';
import AddAlert from '@material-ui/icons/AddAlert';
import Snackbar from 'components/Snackbar/Snackbar.jsx';

import CircularProgress from '@material-ui/core/CircularProgress';

import AdminApprovePageStyle from 'assets/jss/material-dashboard-pro-react/views/AdminApprovePageStyle';
import uuid from 'react-uuid';
import apiCaller from '../../utils/apiCallerOutstanding';
import TransporterFiles from './TransporterFiles';
import firebase from '../../config/config';
import FeatureFlagToastAlert from '../Components/FeatureFlagToastAlert';
import logger from '../../utils/logger.js';
import FeatureOffset from '../Users/FeatureOffset.jsx';
import { mappedCurrentActiveRole } from '../../utils/roleMapping';

const db = firebase.firestore();
const auditLog = firebase.functions().httpsCallable('utilities-auditLog');

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" {...props} ref={ref} />
));
class AdminApproveTransporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: '',
      companyList: {},
      pendingTransporters: [],
      isLoading: false,
      isButtonLoading: [],
      tc: false,
      agentName: '',
      color: 'info',
      featureFlagFiles: '',
      panModal: false,
      panDetailData: {},
      showLoader: false,
      disableFeature: true,
    };
    this.approveTransporter = this.approveTransporter.bind(this);
    this.rejectTransporter = this.rejectTransporter.bind(this);
    this.getPendingTransporters = this.getPendingTransporters.bind(this);
    this.ViewPanDetails = this.ViewPanDetails.bind(this);
    this.addCreditLimitEntries = this.addCreditLimitEntries.bind(this);
  }

  componentDidMount() {
    this.getPendingTransporters();
    this.getFeatureFlagStatus();
  }

  getFeatureFlagStatus() {
    db.collection('FeatureFlags')
      .doc('FileUploadsFeature')
      .onSnapshot(doc => {
        if (doc.exists) {
          const data = doc.data();
          this.setState({ featureFlagFiles: data?.transporterFiles });
        }
      });
  }

  handleClickOpen(modal) {
    const x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    const x = [];
    x[modal] = false;
    this.setState(x);
  }

  /**
   * will return All the Pending Transporters
   * @function
   */
  getPendingTransporters() {
    const pendingTransportersQuery = db
      .collection('Transporters')
      .where('status', '==', 'pending')
      .get();
    const pendingEditTransportersQuery = db
      .collection('Transporters')
      .where('editPending', '==', true)
      .get();

    Promise.all([pendingTransportersQuery, pendingEditTransportersQuery]).then(
      pending => {
        const pendingTransporters = [];
        pending[0].forEach(pendingTransporter => {
          pendingTransporters.push(pendingTransporter.data());
        });
        pending[1].forEach(pendingTransporter => {
          if (pendingTransporter.data().transporterEditData)
            pendingTransporters.push(pendingTransporter.data());
        });
        this.setState({ pendingTransporters });
      }
    );
  }

  /**
   * returns the Ui for Collapsable Card Component Details
   * @function
   */
  getContent = transporter => (
    <GridContainer>
      <GridItem xs={12} sm={12} md={8}>
        <p>
          <span>Email :</span> {transporter.email}
        </p>
      </GridItem>
      <GridItem xs={12} sm={12} md={8}>
        <p>
          <span>Contact :</span>
          {transporter.phoneNumber}
        </p>
      </GridItem>
    </GridContainer>
  );

  // Will Handle The Select Button Element
  handleSimpleSelect = (event, transporter) => {
    const { companyName } = event.target.value;
    const { companyId } = event.target.value;
    const { pendingTransporters } = this.state;
    for (const i in pendingTransporters) {
      if (pendingTransporters[i].uid === transporter.uid) {
        pendingTransporters[i].companyName = companyName;
        pendingTransporters[i].companyId = companyId;
      }
    }
    this.setState({ [event.target.name]: pendingTransporters });
  };

  async ViewPanDetails(num) {
    this.handleClickOpen('panModal');
    this.setState({
      showLoader: true,
    });
    const userDetails = firebase.auth().currentUser;

    const { Aa: token } = userDetails;

    const endPoint = `pipe/pan-details?pan_number=${num}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const value = response?.data;
      this.setState({
        showLoader: false,
        panDetailData: value,
      });
    } catch (e) {
      logger.error(e);
      this.handleClose('panModal');
    }
  }

  async addCreditLimitEntries(id) {
    const { activeRole } = this.props;
    const currentActiveRole = mappedCurrentActiveRole(activeRole);
    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;
    const body = {
      transporter_id: id,
      role: currentActiveRole,
    };
    const endPoint = `transporter/v1/add-credit-limit-entries`;
    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
    } catch (e) {}
  }

  showPanDialog() {
    const { classes } = this.props;
    const { panModal, panDetailData, showLoader } = this.state;
    const isPanDetailDataEmpty =
      panDetailData?.pan_status === '' ||
      panDetailData?.pan_status === 'INVALID';

    return (
      <Dialog
        classes={{
          root: `${classes.center}`,
        }}
        fullWidth
        maxWidth="sm"
        open={panModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => this.handleClose('panModal')}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <div className={classes.modalHeaderContent}>
            <h4 className={classes.modalTitle}>PAN Validation Details</h4>
          </div>
        </DialogTitle>

        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          {showLoader === true ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </div>
          ) : isPanDetailDataEmpty ? (
            <div
              style={{
                backgroundColor: '#FDE8E8',
                border: '1px solid #d32f2f',
                color: 'black',
                padding: '10px',
                borderRadius: '5px',
                paddingLeft: '110px',
              }}
            >
              <img
                style={{
                  paddingRight: '10px',
                }}
                src={infoIcon}
                alt=""
              />
              Invalid! PAN number or details does not exist
            </div>
          ) : (
            <div>
              {/* Render the PAN detail data */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Verified Name</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.verified_name}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Name on PAN</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.name_pan_card}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>DOB</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_date_of_birth}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Type</p>
                <p style={{ fontWeight: 'bold' }}>{panDetailData?.pan_type}</p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Status</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_status}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Aadhaar Linked</p>
                <p style={{ fontWeight: 'bold', color: 'green' }}>
                  {panDetailData?.pan_aadhaar_linked && (
                    <img src={greenTick} alt="icon" />
                  )}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Gender</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_gender}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>PAN Email</p>
                <p style={{ fontWeight: 'bold' }}>{panDetailData?.pan_email}</p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Address State</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_address?.city}
                  {panDetailData?.pan_address?.state}
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px',
                }}
              >
                <p>Address Pincode</p>
                <p style={{ fontWeight: 'bold' }}>
                  {panDetailData?.pan_address?.pincode}
                </p>
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions className={classes.modalFooter}>
          <Button onClick={() => this.handleClose('panModal')}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * will return the Card
   * @function
   */
  getCards() {
    const { classes, activeRole } = this.props;
    const {
      pendingTransporters,
      isButtonLoading,
      featureFlagFiles,
    } = this.state;
    let author = '';
    return (
      <React.Fragment>
        {pendingTransporters.map(transporter => {
          if (transporter.editPending) {
            //  Passing the Edited Details of the transporter to the render and onClick functions.
            transporter = transporter.transporterEditData;
            if (transporter.editedByName) {
              author = transporter.editedByName;
            }
            transporter.isEdit = true;
            transporter.editPending = true;
          } else {
            transporter.isEdit = false;
            author = transporter.createdByName;
          }
          return (
            <GridItem
              xs={12}
              sm={12}
              md={4}
              lg={4}
              key={transporter.transporterId}
            >
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }}
                >
                  <h4 className={classes.cardTitle}>
                    {transporter.name} {transporter.isEdit && '(Edited)'}
                  </h4>
                  {transporter?.isSelfCreated && (
                    <Chip
                      style={{
                        marginLeft: '5px',
                        backgroundColor: '#FCD21F',
                        fontWeight: 700,
                        fontSize: '14px',
                      }}
                      label="SELF SIGN-UP"
                      color="warning"
                      size="small"
                    />
                  )}
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>Email : </span> {transporter.email}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>Contact Person : </span>
                        {transporter.contactPerson}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>Contact : </span>
                        {transporter.phoneNumber}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>GST : </span>
                        {transporter.gstNumber || 'None'}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>PAN : </span>
                        {transporter.panNumber || 'None'}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>TAN : </span>
                        {transporter.tanNumber || 'None'}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>TDS Deduction: </span>
                        {(() => {
                          if (transporter.tdsDeduction === 'lobb') {
                            return 'Deducted by Lobb';
                          }
                          if (transporter.tdsDeduction === 'trucker') {
                            return 'Deducted by Trucker';
                          }
                          if (transporter.tdsDeduction === 'none') {
                            return 'Deducted by None';
                          }
                          return ' -';
                        })()}
                      </p>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>
                        <span>Author : </span>
                        {author || 'None'}
                      </p>
                    </GridItem>
                    <GridItem
                      style={{ textAlign: 'center' }}
                      xs={12}
                      sm={12}
                      md={12}
                    >
                      <Box>
                        <Button
                          color="success"
                          onClick={() =>
                            this.ViewPanDetails(transporter?.panNumber)
                          }
                          className={classes.updateProfileButton}
                          simple
                          disabled={
                            featureFlagFiles === 1 || !transporter?.panNumber
                          }
                        >
                          VIEW PAN DETAILS
                        </Button>
                      </Box>
                    </GridItem>

                    <GridItem xs={12}>
                      <TransporterFiles
                        transporterData={transporter}
                        activeRole={activeRole}
                        featureFlagFiles={featureFlagFiles}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  {isButtonLoading[transporter.transporterId] ? (
                    <CircularProgress
                      className={classes.progress}
                      style={{ color: purple[500] }}
                      thickness={7}
                    />
                  ) : (
                    <React.Fragment>
                      <Button
                        onClick={() =>
                          this.rejectTransporter(
                            transporter,
                            transporter.transporterId
                          )
                        }
                        className={classes.updateProfileButton}
                        disabled={featureFlagFiles === 1}
                      >
                        Reject
                      </Button>
                      <Button
                        color="success"
                        onClick={() =>
                          this.approveTransporter(
                            transporter,
                            transporter.transporterId
                          )
                        }
                        className={classes.updateProfileButton}
                        disabled={featureFlagFiles === 1}
                      >
                        Approve
                      </Button>
                    </React.Fragment>
                  )}
                </CardFooter>
              </Card>
            </GridItem>
          );
        })}
      </React.Fragment>
    );
  }

  /**
   * will return the notification snackbar
   * @param {string} place
   */
  showNotification(place, name) {
    this.setState({
      agentName: name,
    });
    if (!this.state[place]) {
      const x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(() => {
        x[place] = false;
        this.setState(x);
      }, 6000);
    }
  }

  /**
   * Approve Transporter
   * @function
   */
  approveTransporter(transporter, id) {
    const { isButtonLoading } = this.state;
    const { userDetails, systemDetails } = this.props;
    isButtonLoading[id] = true;
    this.setState({
      isButtonLoading,
    });

    if (transporter.isEdit) {
      const transporterRef = db.collection(`Transporters`);
      transporterRef
        .doc(`${transporter.transporterId}`)
        .update({
          ...transporter,
          editPending: false,
          modifiedAt: new Date(),
        })
        .then(() => {
          transporterRef
            .doc(`${transporter.transporterId}`)
            .collection('EditLog')
            .add({ ...transporter, status: 'approved' });
          const { pendingTransporters } = this.state;
          for (const i in pendingTransporters) {
            if (
              pendingTransporters[i].transporterId === transporter.transporterId
            ) {
              pendingTransporters.splice(i, 1);
            }
          }

          const auditBody = {
            data: {
              ...transporter,
              status: 'approved',
            },
            collection: 'Transporters',
            updatedBy: userDetails.uid,
            systemDetails,
            type: 'Approve Transporter',
            message: `${userDetails.email} approved Transporter EDIT with name ${transporter.name}`,
          };
          auditLog(auditBody);

          const NotificationMessage = `${transporter.name} Transporter Approved `;
          this.showNotification('tc', NotificationMessage);
          isButtonLoading[id] = false;
          this.setState({
            pendingTransporters,
            isButtonLoading,
            color: 'info',
          });
        })
        .catch(err => {
          const errorBody = {
            message: `${userDetails.email} tried to approve Transporter EDIT with name ${transporter.name} but FAILED`,
            status: 'fail',
            error: err,
            updatedBy: userDetails.uid,
            errorMessage: err.message,
            collection: 'Transporters',
            systemDetails,
          };
          auditLog(errorBody);
          this.setState({ isLoading: false });
        });
    } else {
      const transporterRef = db.collection(`Transporters`);
      transporterRef
        .doc(`${transporter.transporterId}`)
        .update({ status: 'approved', modifiedAt: new Date() })
        .then(() => {
          transporterRef
            .doc(`${transporter.transporterId}`)
            .collection('EditLog')
            .add({ ...transporter, status: 'approved' })
            .then(() => {
              const data = {
                orgId: transporter.transporterId,
                name: transporter.contactPerson,
                phoneNumber: transporter.phoneNumber,
                role: 'org',
                userType: 'transporter',
                userActive: true,
                customerId: uuid(),
                createdAt: new Date(),
                modifiedAt: new Date(),
              };
              db.collection('Customers')
                .doc(data.customerId)
                .set(data);
            });
          const { pendingTransporters } = this.state;
          for (const i in pendingTransporters) {
            if (
              pendingTransporters[i].transporterId === transporter.transporterId
            ) {
              pendingTransporters.splice(i, 1);
            }
          }

          const auditBody = {
            data: {
              ...transporter,
              status: 'approved',
            },
            collection: 'Transporters',
            updatedBy: userDetails.uid,
            systemDetails,
            type: 'Approve Transporter',
            message: `${userDetails.email} approved Transporter with name ${transporter.name}`,
          };
          auditLog(auditBody);

          const NotificationMessage = `${transporter.name} Transporter Approved `;
          this.showNotification('tc', NotificationMessage);
          isButtonLoading[id] = false;
          this.setState({
            pendingTransporters,
            isButtonLoading,
            color: 'info',
          });
        })
        .then(() => this.addCreditLimitEntries(id))
        .catch(err => {
          const errorBody = {
            message: `${userDetails.email} tried to approve Transporter with name ${transporter.name} but FAILED`,
            status: 'fail',
            error: err,
            updatedBy: userDetails.uid,
            errorMessage: err.message,
            collection: 'Transporters',
            systemDetails,
          };
          auditLog(errorBody);
          this.setState({ isLoading: false });
        });
    }
  }

  /**
   * Reject Transporter
   * @function
   */
  rejectTransporter(transporter, id) {
    const { isButtonLoading } = this.state;
    const { userDetails, systemDetails } = this.props;
    isButtonLoading[id] = true;
    this.setState({
      isButtonLoading,
    });

    if (transporter.isEdit) {
      const transporterRef = db.collection(`Transporters`);
      transporterRef
        .doc(transporter.transporterId)
        .update({
          editPending: false,
        })
        .then(() => {
          transporterRef
            .doc(`${transporter.transporterId}`)
            .collection('EditLog')
            .add({ ...transporter, status: 'rejected' });

          const { pendingTransporters } = this.state;
          for (const i in pendingTransporters) {
            if (
              pendingTransporters[i].transporterId === transporter.transporterId
            ) {
              pendingTransporters.splice(i, 1);
            }
          }

          const auditBody = {
            data: {
              ...transporter,
              status: 'rejected',
            },
            collection: 'Transporters',
            updatedBy: userDetails.uid,
            systemDetails,
            type: 'Reject Transporter',
            message: `${userDetails.email} rejected Transporter EDIT with name ${transporter.name}`,
          };
          auditLog(auditBody);

          const { isButtonLoading } = this.state;
          isButtonLoading[id] = false;
          const NotificationMessage = `${transporter.name} Transporter Rejected `;
          this.showNotification('tc', NotificationMessage);
          this.setState({
            pendingTransporters,
            isButtonLoading,
            color: 'danger',
          });
        })
        .catch(err => {
          const errorBody = {
            message: `${userDetails.email} tried to reject Transporter EDIT with name ${transporter.name} but FAILED`,
            status: 'fail',
            error: err,
            updatedBy: userDetails.uid,
            errorMessage: err.message,
            collection: 'Transporters',
            systemDetails,
          };
          auditLog(errorBody);
          isButtonLoading[id] = false;
          this.setState({ isButtonLoading });
        });
    } else {
      const transporterRef = db.collection(`Transporters`);
      transporterRef
        .doc(`${transporter.transporterId}`)
        .update({ status: 'rejected', modifiedAt: new Date() })
        .then(() => {
          transporterRef
            .doc(`${transporter.transporterId}`)
            .collection('EditLog')
            .add({ ...transporter, status: 'rejected' });
          const { pendingTransporters } = this.state;
          for (const i in pendingTransporters) {
            if (
              pendingTransporters[i].transporterId === transporter.transporterId
            ) {
              pendingTransporters.splice(i, 1);
            }
          }

          const auditBody = {
            data: {
              ...transporter,
              status: 'rejected',
            },
            collection: 'Transporters',
            updatedBy: userDetails.uid,
            systemDetails,
            type: 'Reject Transporter',
            message: `${userDetails.email} rejected Transporter with name ${transporter.name}`,
          };
          auditLog(auditBody);

          const { isButtonLoading } = this.state;
          isButtonLoading[id] = false;
          const NotificationMessage = `${transporter.name} Transporter Rejected `;
          this.showNotification('tc', NotificationMessage);
          this.setState({
            pendingTransporters,
            isButtonLoading,
            color: 'danger',
          });
        })
        .catch(err => {
          const errorBody = {
            message: `${userDetails.email} tried to reject Transporter with name ${transporter.name} but FAILED`,
            status: 'fail',
            error: err,
            updatedBy: userDetails.uid,
            errorMessage: err.message,
            collection: 'Transporters',
            systemDetails,
          };
          auditLog(errorBody);
          const { isButtonLoading } = this.state;
          isButtonLoading[id] = false;
          this.setState({ isButtonLoading });
        });
    }
  }

  render() {
    const { classes } = this.props;
    const { featureFlagFiles, disableFeature } = this.state;

    const { pendingTransporters, color, tc, agentName } = this.state;
    return disableFeature ? (
      <FeatureOffset />
    ) : (
      <div>
        {featureFlagFiles === 1 && <FeatureFlagToastAlert />}
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Card>
              <CardHeader className={`${classes.cardHeader}`} color="warning">
                <p className={`${classes.cardHeader}`}>Approve Transporters</p>
                <h3 className={classes.cardTitle}>
                  {pendingTransporters.length} <small />
                </h3>
              </CardHeader>
              <CardBody className={`${classes.cardHeader}`}>
                {pendingTransporters.length <= 0 && (
                  <p className={classes.textCenter}>No Pending Transporters</p>
                )}
                <GridContainer>{this.getCards()}</GridContainer>
                {this.showPanDialog()}
              </CardBody>
              <CardFooter stats>
                <div className={classes.stats} />
              </CardFooter>
            </Card>
            <Snackbar
              place="tc"
              color={color}
              icon={AddAlert}
              message={agentName}
              open={tc}
              closeNotification={() => this.setState({ tc: false })}
              close
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

AdminApproveTransporter.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  userDetails: state.main.userDetails,
  systemDetails: state.main.systemDetails,
  activeRole: state.main.activeRole,
});

export default connect(mapStateToProps)(
  withStyles(AdminApprovePageStyle)(AdminApproveTransporter)
);
